import { createAction, createNetworkActions } from "~/utils/actions";

export default {
	...createNetworkActions("CUSTOMER"),
	...createNetworkActions("BANK_CONTACT_INFO"),
	...createNetworkActions("SAMTYKKE_UPDATE"),
	...createNetworkActions("EMAIL_UPDATE"),
	...createNetworkActions("FATCA_DATA"),
	...createNetworkActions("FATCA_DATA_UPDATE"),
	...createNetworkActions("PHONE_NUMBER_UPDATE"),
	...createNetworkActions("BEKREFT_KONTAKT_INFO"),
	...createNetworkActions("CUSTOMER_F2100_ACCOUNT_NUMBER"),
	...createNetworkActions("SET_CUSTOMER_F2100_ACCOUNT_NUMBER"),
	...createNetworkActions("UPDATE_MARKEDSFORING_SAMTYKKE"),
	...createNetworkActions("UPDATE_DYBDE_SAMTYKKE"),
	...createNetworkActions("UPDATE_NORSK_PENSJON_SAMTYKKE"),
	...createNetworkActions("UPDATE_DIGITALT_FORSTEVALG_SAMTYKKE"),
	...createAction("CUSTOMER_TIMEOUT"),
	...createNetworkActions("FETCH_LO_FORVALTNINGSFORM"),
	...createNetworkActions("UPDATE_RISK_ASSESSMENT_REMINDER"),
	...createNetworkActions("IS_LO_MEMBER"),
	...createNetworkActions("GET_DISTRIBUTOR"),
};
